const state = {
  sections: [],
};

const mutations = {
  addSection(state, section) {
    state.sections.push(section);
  },
};

export default {
  state,
  mutations,
  namespaced: true,
};
